import { Fade } from '@mui/material'
import { Box } from '@mui/system'
import ReactLoading from 'react-loading'
import { theme } from 'theme'

const Loading = ({ isLoading = true }) => {
  return (
    <Fade in={isLoading} timeout={1000} appear={false}>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          background: 'rgba(242, 239, 234, 0.4)',
          backdropFilter: 'blur(8px)',
          zIndex: 100,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box marginTop="49vh">
          <ReactLoading
            type="spinningBubbles"
            color={theme.palette.primary.main}
            width={128}
            height={128}
          />
        </Box>
      </Box>
    </Fade>
  )
}

export default Loading
